import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DepartmentCode, PortalId } from '@gk/gk-modules';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { MainRoutes } from '../../guards/guard.models';
import { SourcePortalIdQueryParam } from '../../modules/granting-rights-portal/services/new-grant-request-form/new-grant-request-form.model';

@Component({
  selector: 'app-redirect-to-granting-rights-modal',
  templateUrl: './redirect-to-granting-rights-modal.component.html',
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RedirectToGrantingRightsModalComponent {
  @Input() portalId: PortalId;
  @Input() i18nObjectName = 'REDIRECT_TO_GRANTING_RIGHTS';

  constructor(
    private modal: NgbActiveModal,
    private router: Router,
  ) {}

  redirect(): void {
    this.router
      .navigate([MainRoutes.GrantingRights], {
        queryParams: {
          [SourcePortalIdQueryParam]: this.portalId,
        },
      })
      .then(() => {
        this.modal.close(true);
      });
  }

  cancel(): void {
    this.router
      .navigate([`/${MainRoutes.Department}`, DepartmentCode.Geodesy])
      .then(() => {
        this.modal.close(false);
      });
  }

  getTranslationKey(objectKey: string): string {
    return `${this.i18nObjectName}.${objectKey}`;
  }
}
